/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  PostApiStandbyFinTunnel401,
  PostApiStandbyFinTunnel403,
  PostApiStandbyFinTunnel502,
  RetourPartenaireResponse,
} from '../placementApi.schemas.ts';

import postApiStandbyFinTunnelMutator from '.././mutator/placement-instance.ts';

/**
 * Passerelle vers l'API Souscrire En Ligne (SEL). Scrute le retour partenaire de fin de tunnel pour un token de souscription et relaie l'issue de l'opération. La requête peut rester en attente jusqu'à ~60s côté SEL.
 * @summary Récupérer le retour partenaire de fin de tunnel
 */
export const postApiStandbyFinTunnel = (token: string, signal?: AbortSignal) => {
  return postApiStandbyFinTunnelMutator<RetourPartenaireResponse>({
    url: `/api/standby-fin-tunnel/${token}`,
    method: 'POST',
    signal,
  });
};

export const getPostApiStandbyFinTunnelMutationKey = () => ['postApiStandbyFinTunnel'] as const;

export const getPostApiStandbyFinTunnelMutationOptions = <
  TError = PostApiStandbyFinTunnel401 | PostApiStandbyFinTunnel403 | PostApiStandbyFinTunnel502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiStandbyFinTunnel>>,
    TError,
    PostApiStandbyFinTunnelMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiStandbyFinTunnel>>,
  TError,
  PostApiStandbyFinTunnelMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiStandbyFinTunnelMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiStandbyFinTunnel>>,
    PostApiStandbyFinTunnelMutationVariables
  > = (props) => {
    const { token } = props ?? {};

    return postApiStandbyFinTunnel(token);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiStandbyFinTunnelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStandbyFinTunnel>>>;

export type PostApiStandbyFinTunnelMutationError =
  PostApiStandbyFinTunnel401 | PostApiStandbyFinTunnel403 | PostApiStandbyFinTunnel502;
export type PostApiStandbyFinTunnelMutationVariables = { token: string };

/**
 * @summary Récupérer le retour partenaire de fin de tunnel
 */
export const usePostApiStandbyFinTunnel = <
  TError = PostApiStandbyFinTunnel401 | PostApiStandbyFinTunnel403 | PostApiStandbyFinTunnel502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiStandbyFinTunnel>>,
      TError,
      PostApiStandbyFinTunnelMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiStandbyFinTunnel>>,
  TError,
  PostApiStandbyFinTunnelMutationVariables,
  TContext
> => {
  return useMutation(getPostApiStandbyFinTunnelMutationOptions(options), queryClient);
};
